import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function AboutSection() {
  return <section className="py-24 px-6 bg-[#f5f4f1] overflow-hidden" data-id="element-96">
      <div className="max-w-[1800px] mx-auto" data-id="element-97">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-98">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} className="lg:col-span-5 order-2 lg:order-1" data-id="element-99">
            <span className="text-sm md:text-base font-display font-bold uppercase tracking-[0.3em] md:tracking-[0.4em] mb-6 block text-black/60" data-id="element-100">
              Our Heritage
            </span>
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-display font-bold mb-6 tracking-[0.05em] md:tracking-[0.2em] uppercase leading-tight" data-id="element-101">
              Djily Creations
            </h2>
            <p className="text-base md:text-lg font-light tracking-widest text-black/70 leading-relaxed uppercase mb-8 max-w-md" data-id="element-102">
              A sanctuary of cultural authority where ancestral African
              craftsmanship meets contemporary luxury. We preserve the rich
              textile traditions of the continent, reimagining them for the
              global modern wardrobe.
            </p>
            <Link to="/about" className="inline-block border-b border-black pb-1 text-xs font-display uppercase tracking-widest hover:opacity-50 transition-opacity" data-id="element-103">
              Discover Our Story
            </Link>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} className="lg:col-span-7 order-1 lg:order-2 relative" data-id="element-104">
            <div className="aspect-[21/9] bg-grey-divider overflow-hidden relative" data-id="element-105">
              <img src="https://cdn.magicpatterns.com/uploads/9r3nX71JfeKabU2grgHW7d/image.png" alt="Djily Creations Heritage" className="w-full h-full object-cover grayscale contrast-125" data-id="element-106" />
              <div className="absolute inset-0 bg-black/10" data-id="element-107" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}